import { Tabs } from "@closer/ui";
import { Outlet, useLocation, useNavigate } from "react-router";

import { useAuth } from "../../lib/authContext";
import { visibleClientSections } from "../../lib/clientSections";

/**
 * Müvekkiller kabuğu (D03 — CLOS-875).
 *
 * `ContractsLayout` ve `OrganizationLayout` deseninin aynısı — yeni bir desen icat
 * edilmedi (refleks 1). Bölümler AYRI ROTALAR, sekme durumu değil: kullanıcı bir bölümü
 * bağlantı olarak paylaşabilmeli ve yenilemede bağlam kaybolmamalı.
 *
 * ⚠ MÜVEKKİL DETAYI kabuğun DIŞINDA (`ContractsLayout` ile aynı karar): gezinme çubuğu
 * bölüm sayfalarına ait, tek bir müvekkilin detayına değil.
 */
export function ClientsLayout() {
  const { can } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const sections = visibleClientSections(can);

  return (
    <div className="flex w-full flex-col gap-6">
      {/* Tek bölüm görünüyorsa gezinme çizmek anlamsız: tıklanacak bir yer yok. */}
      {sections.length > 1 ? (
        <Tabs
          label="Müvekkiller"
          items={sections.map((section) => ({ key: section.key, label: section.label }))}
          activeKey={sections.find((s) => s.route === location.pathname)?.key ?? null}
          onSelect={(key) => {
            const hedef = sections.find((s) => s.key === key);
            if (hedef) void navigate(hedef.route);
          }}
        />
      ) : null}
      <Outlet />
    </div>
  );
}
